// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RowSalaryHead .RowSalaryHead__total {\n  border-top: 2px solid lightgray;\n  border-left: 2px solid lightgray;\n  border-right: 2px solid lightgray; }\n\n.RowSalaryHead .RowSalaryHead__detail {\n  border: 1px solid lightgray;\n  border-bottom: 2px solid lightgray; }\n\n.RowSalaryHead .RowSalaryHead__detail--right-border {\n  border-right: 2px solid lightgray; }\n", ""]);
// Exports
module.exports = exports;
